import { FC } from 'react'
import { AutocompleteInput, ReferenceInput } from 'react-admin'

interface PropTypes {
  fieldId: string
  source: string
  reference: string
  optionText?: string
  optionValue?: string
  filter?: object
  perPage?: number
}

const ReferenceFilter: FC<PropTypes> = ({
  source,
  fieldId,
  reference,
  optionText = 'name',
  optionValue = 'id',
  filter,
  perPage = 100,
}) => {
  const inputSource = `${source}.value.${fieldId}`
  return (
    <ReferenceInput
      source={inputSource}
      reference={reference}
      perPage={perPage}
      filter={filter}
      label=""
    >
      <AutocompleteInput
        source={inputSource}
        optionText={optionText}
        optionValue={optionValue}
        variant="outlined"
        margin="none"
        label={false}
      />
    </ReferenceInput>
  )
}

export default ReferenceFilter

